const mappersFunc = {
  toFixed: (v, r) => parseFloat(v).toFixed(r),
};

export default function dataMapper(data, columnsMappers) {
  let mappers = [];

  for (const column in columnsMappers) {
    mappers[column] = [];
    const mappingFuncObjects = columnsMappers[column];

    for (const mappingFuncKey in mappingFuncObjects) {
      const mappingFunc = mappersFunc[mappingFuncKey];

      mappers[column].push((value) =>
        mappingFunc(value, mappingFuncObjects[mappingFuncKey]),
      );
    }
  }

  return data.map((row) => {
    const keys = Object.keys(row);
    let mappedRow = { ...row };
    keys.forEach((key) => {
      const columnMapperFuns = mappers[key];
      if (columnMapperFuns) {
        columnMapperFuns.forEach((fun) => {
          mappedRow[key] = fun(mappedRow[key]);
        });
      }
    });
    return mappedRow;
  });
}
